import { mehirApi } from '@mehir/api/api';
import type { ContractStatsViewModel } from '@mehir/api/contract-api';
import type { CampaignStatsViewModel } from '@mehir/api/campaign-api';

/**
 * contract-api and campaign-api each generate an endpoint named `getStats`
 * from their own OpenAPI document. Both inject into the same api instance, and
 * RTK Query keeps the first definition for a duplicated name — so the contract
 * stats hook silently resolved to the campaign stats endpoint, and the
 * dashboard's contract KPIs were reading campaign numbers.
 *
 * The generated files must not be hand-edited, so the two are re-declared here
 * under distinct names. The real fix belongs in the codegen config (give the
 * operations unique operationIds per service); once that lands, this module can
 * go away in favour of the generated hooks.
 */
export const statsApi = mehirApi.injectEndpoints({
  endpoints: (build) => ({
    getContractStats: build.query<ContractStatsViewModel, void>({
      query: () => ({ url: `/contractservice/v1/Backoffice/backoffice/contracts/stats` }),
      providesTags: ['Contract'],
    }),
    getCampaignStats: build.query<CampaignStatsViewModel, void>({
      query: () => ({ url: `/campaignservice/v1/Backoffice/backoffice/campaigns/stats` }),
      providesTags: ['Campaigns'],
    }),
  }),
});

export const { useGetContractStatsQuery, useGetCampaignStatsQuery } = statsApi;
